import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for CSAT user suggestions heading customisation
 * Returns heading text and styling
 */
export const useCsatUserSuggestionsHeadingCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CSAT,
    sectionKey: PUI.CSAT_SECTION_KEYS.USER_SUGGESTIONS_HEADING,
    blockKey: PUI.CSAT_BLOCK_KEYS.USER_SUGGESTIONS,
  });

  const textContent = getField(PUI.COMMON_FIELD_KEYS.TEXT_CONTENT);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);

  return {
    isVisible,
    textContent,
    textColor,
  };
};

/**
 * Composable for CSAT suggestion options customisation
 * Returns styling for improvement category buttons
 */
export const useCsatSuggestionOptionsCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CSAT,
    sectionKey: PUI.CSAT_SECTION_KEYS.SUGGESTION_OPTIONS,
    blockKey: PUI.CSAT_BLOCK_KEYS.USER_SUGGESTIONS,
  });

  const suggestionOption1 = getField(PUI.COMMON_FIELD_KEYS.OPTION_1);
  const suggestionOption2 = getField(PUI.COMMON_FIELD_KEYS.OPTION_2);
  const suggestionOption3 = getField(PUI.COMMON_FIELD_KEYS.OPTION_3);
  const suggestionOption4 = getField(PUI.COMMON_FIELD_KEYS.OPTION_4);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const textColor = getField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);
  const selectedBorderColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_BORDER_COLOR);
  const selectedBackgroundColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_BACKGROUND_COLOR);
  const selectedTextColor = getField(PUI.COMMON_FIELD_KEYS.SELECTED_TEXT_COLOR);

  return {
    isVisible,
    backgroundColor,
    textColor,
    borderColor,
    suggestionOption1,
    suggestionOption2,
    suggestionOption3,
    suggestionOption4,
    selectedBorderColor,
    selectedBackgroundColor,
    selectedTextColor,
  };
};

/**
 * Composable for CSAT suggestion box (textarea) customisation
 * Returns styling for the comment textarea
 */
export const useCsatSuggestionBoxCustomisation = () => {
  const { getField, isVisible } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CSAT,
    sectionKey: PUI.CSAT_SECTION_KEYS.SUGGESTION_BOX,
    blockKey: PUI.CSAT_BLOCK_KEYS.USER_SUGGESTIONS,
  });

  const placeholderText = getField(PUI.COMMON_FIELD_KEYS.PLACEHOLDER_TEXT);
  const backgroundColor = getField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const placeholderColor = getField(PUI.COMMON_FIELD_KEYS.PLACEHOLDER_COLOR);
  const borderColor = getField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);

  return {
    isVisible,
    placeholderText,
    backgroundColor,
    placeholderColor,
    borderColor,
  };
};
